import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminNavbar from './AdminNavbar';

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <AdminSidebar isOpen={isSidebarOpen} />
      
      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      <div className="flex-1 w-full lg:w-[calc(100%-18rem)] lg:ml-72 flex flex-col transition-all duration-300">
        <AdminNavbar toggleSidebar={toggleSidebar} />
        <div className="px-4 sm:px-8 py-8 flex-1">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
